import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as RegionsActions from '../actions/region.actions';
import {catchError, exhaustMap, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import { environment } from '../../../../environments/environment';
import {RegionsService} from '../../../core/services/regions.service';
import * as Reducers from '../reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class RegionsEffects {

  getRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionsActions.getRegions, RegionsActions.refreshRegions),
      withLatestFrom(
        this.store$.select(Reducers.getRegions)
      ),
      switchMap(([action, regions]) => {
          if (regions && action.type !== RegionsActions.refreshRegions.type) {
            return of(RegionsActions.getRegionsSuccess({regions}));
          }
          return this.regionsService.getRegions().pipe(
            exhaustMap(data => of(RegionsActions.getRegionsSuccess({regions: data}))),
            catchError(error => of(RegionsActions.getRegionsFailure({error})))
          );
        }
      )
    )
  );

  persistRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionsActions.getRegionsSuccess),
      tap((action: any) => {
        try {
          localStorage.setItem(`${environment.storagePrefix}.cachedRegions`, JSON.stringify(action.regions));
        } catch { }
      })
    ), { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private regionsService: RegionsService
  ) { }
}
